import './GroupedAccountList.scss';
import React from 'react';

export const GroupedAccountList = ({ groupClassification, children }) => (
  <span className={`grouped-account-list-container ${groupClassification}`}>
    {children}
  </span>
);
